import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MultiLanguageService } from "@share/translate";

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private meta: Meta, private title: Title,private translate: MultiLanguageService) {}

  updateMeta(title: string='',
             description: string=this.translate.instant("home_page_description"),
             keywords: string = this.translate.instant("home_page_keywords")) {
    if (title=='')
      title = this.translate.instant("gopon_title")
    else
      title = this.translate.instant("gopon_title") + ' - ' + title;

    this.title.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
  }
}
